<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>付款退款页面管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="退款单ID"
                        prop="id">
            <el-input placeholder="请输入付款退款单ID"
                      v-model="search.id"></el-input>
          </el-form-item>
          <el-form-item label="创建人"
                        prop="creator_id">
            <remote-select
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="请输入申请人名称，仅显示活跃状态的管理员"
              v-model="search.creator_id"
              :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1,2,3,5], status_lists: [1,2]}))"
              :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
          <!-- <el-form-item label="创建人部门"
                        prop="department_id">
            <remote-select
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="请输入部门名称"
              v-model="search.department_id"
              :query-request="fetchDepartments"
              :find-request="getDepartmentDetail">
            </remote-select>
          </el-form-item> -->
          <el-form-item label="创建时间"
                        prop="created_at">
            <el-date-picker
              v-model="search.created_at"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              align="center"
              class="width-max"
              :default-time="['00:00:00', '23:59:59']"
              clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="退款日期"
                        prop="refund_date">
            <el-date-picker
              v-model="search.refund_date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="center"
              class="width-max"
              :default-time="['00:00:00', '23:59:59']"
              clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="退款金额"
                        prop="refund_amount">
            <el-col :span="11">
              <el-form-item prop='apply_amount_min'>
                <el-input v-model="search.refund_amount_min" placeholder="请输入退款金额起始值"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <p style="padding: 0; margin: 0; text-align: center">至</p>
            </el-col>
            <el-col :span="11">
              <el-form-item prop='apply_amount_max'>
                <el-input v-model="search.refund_amount_max" placeholder="请输入退款金额起始值"></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>

          <el-form-item label="付款公司"
                        prop="payment_company">
            <remote-select
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="仅支持搜索启用中的付款公司,可输入名称进行搜索"
              v-model="search.payment_company"
              :query-request="(_)=>fetchOurCompanies(Object.assign(_, {is_disabled: 0}))"
              :find-request="getOurCompaniesDetail">
            </remote-select>
          </el-form-item>

        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportSearch()">导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>

      <div class="margin b15">
        <el-button v-if="$route.meta.tye === 'finance'"
                   type="primary"
                   icon="sj-icon-export"
                   @click="onExportFinanceSearch"
                   size="small">按财务格式导出
        </el-button>
        <el-button type="primary"
                   icon="sj-icon-export"
                   @click="onExportDetailSearch"
                   size="small">导出付款退款明细
        </el-button>
        <el-button type="primary"
                   @click="showSummaryVisible"
                   size="small">按搜索结果汇总
        </el-button>
        <el-button type="primary"
                   icon="sj-icon-pdf"
                   @click="downloadRefundPDFS"
                   :disabled="!multipleSelection.length"
                   size="small">批量生成PDF
        </el-button>
      </div>

      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%"
                @selection-change="val => this.multipleSelection = val">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>

        <template v-for="(attr, index) of fields">
          <el-table-column v-bind="attr"></el-table-column>
        </template>

        <el-table-column fixed="right"
                         label="操作"
                         width="100">
          <template slot-scope="scope">
            <div class="button-gutter">
              <router-link :to="`/payment-refund/${$route.meta.type}/detail/${scope.row.id}`">
                <el-button size="mini" type="success">查看</el-button>
              </router-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

  <el-dialog
    title="付款汇总"
    :visible="summaryVisible"
    :before-close="() => summaryVisible = false"
    width="50%">
    <el-table :data="refundSummary"
              stripe
              highlight-current-row
              border
              style="width: 100%">
      <el-table-column prop="name"
                       label="状态"
                       width="190">
      </el-table-column>
      <el-table-column prop="refund_total"
                       label="付款退款总金额"
                       min-width="120">
        <template slot-scope="scope">
          {{scope.row.refund_total | seperateThousandsToFixed(2)}}
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer"
        class="dialog-footer" >
      <el-button @click="summaryVisible = false">关闭</el-button>
    </span>
  </el-dialog>
  </div>
</template>

<script>
import { searchRules } from '../payment-refund.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table, { removeEmptyParams } from '@core/mixins/table-v3'
import paymentRefundMixins from '../payment-refund.mixins'
import { exportRefundDetailHeader, exportRefundTableHeader, exportRefundSummaryHeader } from '../payment-refund-export-header'
import moment from 'moment'
import downloadJS from '@/vendor/download'
import { getToken } from '@utils/auth'


export default {
  mixins: [table, dateTimePicker, paymentRefundMixins],
  data () {
    return {
      searchRules,
      search: {
        id: null,
        creator_id: null,
        department_id: null,
        created_at: [],
        refund_date: [],
        payment_company: null,
        refund_amount_min: null,
        refund_amount_max: null,
        is_from_finance: this.$route.meta.type === 'finance',
      },
      searchFieldType: {
        creator_id: Number,
        department_id: Number,
        payment_company: Number,
      },
      exportRefundTableHeader,
      exportRefundDetailHeader,
      exportRefundSummaryHeader,
      multipleSelection: [],
      summaryVisible: false,
      refundSummary: [],
    }
  },
  computed: Vuex.mapState({}),
  created () {},
  methods: {
    ...Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail']),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getPaymentRefundTable', params)
    },
    fetchDepartments (name) {
      return request.common('getFinCenterDepartmentTableList', {query_all: true, ...name})
    },
    getDepartmentDetail (id) {
      return request.common('getFinCenterDepartmentDetail', id)
    },
    fetchOurCompanies (params) {
      return request.common('getFinCenterOurCompaniesTable', params)
    },
    getOurCompaniesDetail (id) {
      return request.common('getFinCenterOurCompaniesDetail', id)
    },
    exportRefundTableData (params) {
      return request.page('exportPaymentRefundTableData', params)
    },
    // 按照财务格式导出付款退款数据
    onExportFinanceSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportRefundTableHeader,
        total: this.pagination.total,
        request: this.exportRefundTableData,
        requestParams: this.search,
        getResponseData: (data) => {
          data.data = this.handleExportData(data.data)
          return data
        }
      })
    },
    handleExportData (data) {
      data.forEach((row) => {
        row.creator_info = row.creator_user_name + '/' + row.creator_real_name
        row.refund_date = this.formatExportDate(row.refund_date)
        row.receipt_name = row.bank_account_snapshot.name || '-'
        row.bank_account = row.bank_account_snapshot.bank_account || '-'
        row.bank = row.bank_account_snapshot.bank || '-'
        row.bank_headquarters = row.bank_account_snapshot.bank_headquarters || '-'
      })
      return data
    },
    formatExportDate (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    exportRefundDetailData (params) {
      return request.page('exportPaymentRefundDetailData', params)
    },
    exportRefundSummaryData (params) {
      return request.page('exportPaymentRefundSummaryData', params)
    },
    // 按照付款明细导出付款退款数据
    onExportDetailSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportRefundDetailHeader,
        total: this.pagination.total,
        request: this.exportRefundDetailData,
        requestParams: this.search,
        getResponseData: (data) => {
          data.data = this.handleExportData(data.data)
          // data.data = this.handleExportDetailData(data.data)
          return data
        }
      })
    },
    // 按搜索结果汇总
    // onExportAggregateSearch () {
    //   this.$export('退款汇总', {
    //     fileHeader: this.exportRefundSummaryHeader,
    //     total: this.pagination.total,
    //     request: this.exportRefundSummaryData,
    //     requestParams: this.search,
    //     getResponseData: (data) => {
    //       return { data }
    //     }
    //   })
    // },
    downloadRefundPDFS () {
      let id = this.multipleSelection.map(_ => _.id)
      request.common('downloadRefundPdfsFiles', {id}).then((data) => {
        let filename = data.data
        let api = request.items.downloadPdfFileFromServer({filename: filename})
        downloadJS(api, false, false, {
          'SJ-Auth-Token': getToken()
        })
      })
    },
    showSummaryVisible () {
      request.page('exportPaymentRefundSummaryData', removeEmptyParams(this.search)).then(({data}) => {
        this.refundSummary = data
        this.summaryVisible = true
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/payment-refund/pages/PaymentRefundTable.vue